(() => {
  function init(root) {
    if (root.dataset.gasReady) return;
    root.dataset.gasReady = 'true';
    const grid = root.querySelector('[data-gas-products]');
    const cards = Array.from(root.querySelectorAll('[data-gas-card]'));
    const filters = Array.from(root.querySelectorAll('[data-gas-filter]'));
    const sort = root.querySelector('[data-gas-sort]');
    const count = root.querySelector('[data-gas-count]');
    const empty = root.querySelector('[data-gas-empty]');
    let selected = 'all';
    filters.forEach(button => {
      const type = button.dataset.gasFilter;
      const total = cards.filter(card => type === 'all' || card.dataset.type === type).length;
      button.hidden = total === 0 && type !== 'all';
      button.querySelector('[data-gas-filter-count]').textContent = total;
    });
    function update(writeUrl = false) {
      let visible = 0;
      const ordered = [...cards].sort((a, b) => {
        const available = Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true');
        if (available) return available;
        if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.rank) - Number(b.dataset.rank);
      });
      const fragment = document.createDocumentFragment();
      ordered.forEach(card => {
        card.hidden = selected !== 'all' && card.dataset.type !== selected;
        if (!card.hidden) visible++;
        fragment.append(card);
      });
      grid.append(fragment);
      filters.forEach(button => {
        const active = button.dataset.gasFilter === selected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      count.textContent = visible;
      empty.hidden = visible > 0;
      if (writeUrl && /^https?:$/.test(location.protocol)) {
        const url = new URL(location.href);
        if (selected === 'all') url.searchParams.delete('product_type');
        else url.searchParams.set('product_type', selected);
        if (sort.value === 'recommended') url.searchParams.delete('studio_sort');
        else url.searchParams.set('studio_sort', sort.value);
        history.replaceState(null, '', url);
      }
    }
    function readUrl() {
      const params = new URL(location.href).searchParams;
      const type = params.get('product_type');
      selected = filters.some(button => button.dataset.gasFilter === type && !button.hidden) ? type : 'all';
      const mode = params.get('studio_sort');
      sort.value = ['price-asc', 'price-desc'].includes(mode) ? mode : 'recommended';
      update();
    }
    filters.forEach(button => button.addEventListener('click', () => { selected = button.dataset.gasFilter; update(true); }));
    sort.addEventListener('change', () => update(true));
    window.addEventListener('popstate', readUrl);
    root.querySelectorAll('[data-gas-controls]').forEach(control => control.hidden = false);
    readUrl();
  }
  function setup(scope = document) { scope.querySelectorAll('[data-gas-collection]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
